// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

/**
 * Web component representing a group of addons
 *
 * @augments LitElement
 */
@customElement( 'uap-page-addons-group-placeholder-item' ) // eslint-disable-line require-jsdoc
export class AutomatorPageAddonsGroupPlaceholderItem extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Renders the component
	 *
	 * @return {TemplateResult|undefined} The template
	 */
	render() {
		return html`
			<div class="item">
				${ this._templateIcon }
				${ this._templateContent }
				${ this._templateCtas }
			</div>
		`;
	}

	/**
	 * Renders the icon
	 *
	 * @return {TemplateResult} The template
	 */
	get _templateIcon() {
		return html`
			<div class="item-icon">
				<uo-placeholder width="48px" height="48px"></uo-placeholder>
			</div>
		`;
	}

	/**
	 * Renders the content
	 *
	 * @return {TemplateResult} The template
	 */
	get _templateContent() {
		return html`
			<div class="item-content">
				<div class="item-content-top">
					${ this._templateName }
					${ this._templateDeveloper }
				</div>

				<div class="item-content-description">
					<uo-placeholder width="80px"></uo-placeholder>
					<uo-placeholder width="100px"></uo-placeholder>
					<uo-placeholder width="50px"></uo-placeholder>
					<uo-placeholder width="150px"></uo-placeholder>
					<uo-placeholder width="70px"></uo-placeholder>
					<uo-placeholder width="50px"></uo-placeholder>
					<uo-placeholder width="110px"></uo-placeholder>
					<uo-placeholder width="70px"></uo-placeholder>
					<uo-placeholder width="45px"></uo-placeholder>
					<uo-placeholder width="120px"></uo-placeholder>
					<uo-placeholder width="120px"></uo-placeholder>
					<uo-placeholder width="40px"></uo-placeholder>
				</div>
				
				${ this._templateDetails }
			</div>
		`;
	}

	/**
	 * Renders the name
	 *
	 * @return {TemplateResult} The template
	 */
	get _templateName() {
		return html`
			<div class="item-content-name">
				<uo-placeholder width="140px"></uo-placeholder> <uo-placeholder width="80px"></uo-placeholder>
			</div>
		`;
	}

	/**
	 * Renders the developer
	 *
	 * @return {TemplateResult} The template
	 */
	get _templateDeveloper() {
		return html`
			<div class="item-content-developer">
				<uo-placeholder width="40px"></uo-placeholder>
				<uo-placeholder width="80px"></uo-placeholder>
				<uo-placeholder width="40px"></uo-placeholder>
				<uo-placeholder width="16px"></uo-placeholder>
			</div>
		`;
	}

	/**
	 * Renders the details
	 *
	 * @return {TemplateResult} The template
	 */
	get _templateDetails() {
		const detailsHeight = '8px';

		return html`
			<div class="item-content-details">
				<div class="item-content-detail">
					<uo-placeholder width="16px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="80px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="150px" height="${ detailsHeight }"></uo-placeholder>
				</div>
				<div class="item-content-detail">
					<uo-placeholder width="16px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="80px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="50px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="15px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="45px" height="${ detailsHeight }"></uo-placeholder>
				</div>
				<div class="item-content-detail">
					<uo-placeholder width="16px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="80px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="50px" height="${ detailsHeight }"></uo-placeholder>
					<uo-placeholder width="15px" height="${ detailsHeight }"></uo-placeholder>
				</div>
			</div>
		`;
	}

	/**
	 * Renders the call-to-action buttons
	 *
	 * @return {TemplateResult|undefined} The template
	 */
	get _templateCtas() {
		return html`
			<div class="item-ctas">
				<uo-placeholder width="110px" height="20px"></uo-placeholder>
			</div>
		`;
	}
}